<template>
</template>

<script>
import {Dialog, Toast} from "vant";
import {wx, wxConfig} from "@/libs/jssdk-util";
export default {
  name: "uploadImage",
  methods:{
    base64ImageSize(base64ImageStr) {
      const indexBase64 = base64ImageStr.indexOf('base64,');
      if (indexBase64 < 0) return -1;
      const str = base64ImageStr.substr(indexBase64 + 6);
      return (str.length * 0.75 / 1024 / 1024).toFixed(2);
    },

    updateAvatar() {
      let that = this
      return new Promise((resolve, reject) => {
        wx.chooseImage({//选择图片
          count: 1,
          sizeType: ['compressed','original'], // 可以指定是原图还是压缩图，默认二者都有
          success: function (res) {
            console.log('选择的图片:', res)
            let localIds = res.localIds
            // window.__wxjs_is_wkwebview  判断ios机型
            wx.getLocalImgData({
              localId: localIds[0],
              success: (res3) => {
                let localData = res3.localData
                // localData = localData.replace('jgp', 'jpeg');//iOS 系统里面得到的数据，类型为 image/jgp,因此需要替换一下
                if (localData.indexOf('data:image') != 0) { //ios返回完整的base64, 安卓返回的没有头部 且其中可能包含换行符
                  localData = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
                }
                let size = that.base64ImageSize(localData)
                if(size > 1){
                  return Toast('图片不得大于1MB');
                }
                resolve(localData)
              }
            })
          },
          fail(err) {
            Dialog.alert({
              title: '打开相册失败',
              message: err.errMsg
            })
          }
        })
      })
    },
  },

  mounted(){
    wxConfig(['chooseImage', 'previewImage', 'getLocalImgData'])
    wx.error(function (err) {
      Dialog.alert({
        title: '微信配置失败，请刷新页面',
        message: JSON.stringify(err)
      })
    });
    console.log(2,'2')
  }
}
</script>

<style scoped>

</style>